import { render, staticRenderFns } from "./Publicidad.vue?vue&type=template&id=6f1d75aa&"
import script from "./Publicidad.vue?vue&type=script&lang=js&"
export * from "./Publicidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports